export function PerplexityAttribution() {
  return (
    <footer className="w-full py-4 text-center text-xs text-muted-foreground">
      <a
        href="https://www.perplexity.ai/computer"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-foreground transition-colors"
      >
        Created with Perplexity Computer
      </a>
    </footer>
  );
}
